import { Box, Grid, SwipeableDrawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MultiPaymentOption from "./MultiPaymentOption";
import _ from "lodash";
import { useEffect } from "react";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";

const MultiPaymentDialog = ({
  open,
  handleClose,
  setSelectedLenderForPayment,
  lendingProviderDues,
}) => {
  const disablePaymentForLendingPartner = (lendingPartner) => {
    // if outstanding amount for this lending partner is 0, then disable payment
    const lendingProviderDue = _.find(
      lendingProviderDues,
      (due) =>
        due?.lendingProviderName === lendingPartner ||
        due?.lendingProvider === lendingPartner
    );

    return (
      !lendingProviderDue ||
      lendingProviderDue?.amount <= 0 ||
      lendingProviderDue?.dueAmount <= 0
    );
  };

  useEffect(() => {
    if (open) {
      AnalyticsService.pushEvent("Drawer Opened", {
        type: "Multi Payment Option on Pay Now",
      });
      AndroidService.unsetPullToRefresh();
    } else {
      AndroidService.setPullToRefresh();
    }
  }, [open]);

  const paymentOptions = [
    {
      title: "AgroStar",
      iconPath: `https://static.agrostar.in/saathi/lending-providers/tr:h-100/AGROSTAR.png`,
      color: "#9D2123",
      lendingPartner: "AGROSTAR",
      disabled: disablePaymentForLendingPartner("AGROSTAR"),
    },
    {
      title: "Rupifi",
      iconPath: `https://static.agrostar.in/saathi/lending-providers/tr:h-100/RUPIFI.png`,
      color: "#174282",
      lendingPartner: "RUPIFI",
      disabled: disablePaymentForLendingPartner("RUPIFI"),
    },
  ];

  // sort payment options: enabled first, then disabled
  const sortedPaymentOptions = paymentOptions.sort((a, b) => {
    return a?.disabled - b?.disabled;
  });

  return (
    <>
      <SwipeableDrawer
        anchor={`bottom`}
        onOpen={() => {}}
        open={open}
        disableDiscovery={true}
        disableSwipeToOpen={true}
        onClose={() => {
          handleClose();
        }}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 30,
            borderTopRightRadius: 30,
            pb: 1,
          },
          zIndex: 1100,
        }}
      >
        <Grid container alignItems={"center"} mt={2} mb={2}>
          <Grid item xs={4}></Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 50,
                height: 6,
                position: "absolute",
                borderRadius: 3,
                backgroundColor: "#ddd",
              }}
            />
          </Grid>
          <Grid item xs={4} textAlign={"end"}>
            <CloseIcon
              onClick={handleClose}
              sx={{
                color: "#CACACA",
                fontSize: "28px",
                cursor: "pointer",
                mr: 2,
              }}
            />
          </Grid>
        </Grid>

        {_.map(sortedPaymentOptions, (paymentOption) => (
          <MultiPaymentOption
            key={paymentOption?.lendingPartner}
            title={paymentOption?.title}
            icon={paymentOption?.icon}
            iconPath={paymentOption?.iconPath}
            color={paymentOption?.color}
            onProceedClick={() => {
              AnalyticsService.pushEvent("Button Clicked", {
                type: "Multi Payment Option on Pay Now",
                lendingPartner: paymentOption?.lendingPartner,
              });
              setSelectedLenderForPayment(paymentOption?.lendingPartner);
            }}
            disabled={paymentOption?.disabled}
          />
        ))}
      </SwipeableDrawer>
    </>
  );
};
export default MultiPaymentDialog;
